<template>
  <div class="the-hub-skeleton" aria-busy="true" aria-live="polite">
    <span class="sr-only">Loading…</span>

    <div v-if="type === 'article'" class="the-hub-skeleton__article">
      <div class="the-hub-skeleton__bar the-hub-skeleton__bar--title"></div>
      <div class="the-hub-skeleton__bar the-hub-skeleton__bar--meta"></div>
      <div class="the-hub-skeleton__bar the-hub-skeleton__bar--nav"></div>
      <div class="the-hub-skeleton__bar the-hub-skeleton__bar--cover"></div>
      <div v-for="line in 8" :key="`line-${line}`" class="the-hub-skeleton__bar the-hub-skeleton__bar--line"></div>
    </div>

    <ul v-else class="row the-hub-skeleton__cards">
      <li v-for="card in cards" :key="`card-${card}`" class="col-12 col-md-6 col-xl-4">
        <div class="the-hub-skeleton__card">
          <div class="the-hub-skeleton__bar the-hub-skeleton__bar--card-title"></div>
          <div class="the-hub-skeleton__bar the-hub-skeleton__bar--meta"></div>
          <div class="the-hub-skeleton__bar the-hub-skeleton__bar--cover"></div>
          <div v-for="line in 4" :key="`card-${card}-line-${line}`" class="the-hub-skeleton__bar the-hub-skeleton__bar--line"></div>
          <div class="the-hub-skeleton__bar the-hub-skeleton__bar--button"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TheHubSkeleton',
  props: {
    type: {
      type: String,
      required: false,
      default: 'list',
      validator: value => ['list', 'article'].includes(value)
    },
    cards: {
      type: Number,
      required: false,
      default: 6
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes the-hub-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}
.the-hub-skeleton {
  &__bar {
    border-radius: 3px;
    background: linear-gradient(90deg, #e9e9e9 25%, #f6f6f6 37%, #e9e9e9 63%);
    background-size: 400% 100%;
    animation: the-hub-shimmer 1.4s ease infinite;
    margin-bottom: 12px;
    &--title {
      width: 70%;
      height: 40px;
      margin: 10px 0 20px;
    }
    &--card-title {
      width: 85%;
      height: 26px;
      margin-bottom: 15px;
    }
    &--meta {
      width: 55%;
      height: 16px;
    }
    &--nav {
      width: 120px;
      height: 16px;
      margin-bottom: 25px;
    }
    &--cover {
      width: 196px;
      max-width: 100%;
      aspect-ratio: 196 / 293;
      margin: 15px auto 25px;
    }
    &--line {
      height: 14px;
      &:last-child,
      &:nth-last-child(2) {
        width: 80%;
      }
    }
    &--button {
      width: 170px;
      height: 40px;
      margin: 15px 0 0;
    }
  }
  &__cards {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  &__card {
    margin-top: 30px;
    padding: 20px 18px 30px;
    background: #f2f2f2;
    border: 1px solid #e9e9e9;
    .the-hub-skeleton__bar {
      background: linear-gradient(90deg, #e2e2e2 25%, #ededed 37%, #e2e2e2 63%);
      background-size: 400% 100%;
    }
  }
}
@media (prefers-reduced-motion: reduce) {
  .the-hub-skeleton__bar {
    animation: none;
  }
}
</style>
